module.exports = __webpack_public_path__ + "img/t1.c40a9514.jpg";